import { ROUTES_APPLICATION_PATH } from "../../../../routes.constants";
import { USER_ROLES } from "../../../../components/components.constants";
import { buildMenu, SECTION_LABELS } from './utils';

export const getIndustryNavigationOptions = (t, tenantContext, userRole, config = {}, options = {}) => {
  const {
    hasAssortmentManagement = false,
  } = tenantContext;

  const {
    includeSortimento = hasAssortmentManagement,
  } = config;

  const isFashionDesigner = userRole === USER_ROLES.FASHION_DESIGNER;

  const sortimento = buildMenu({
    menuName: "Sortimento",
    route: ROUTES_APPLICATION_PATH.SORTIMENTO.BASE_URL,
    icon: "sortimento",
    sectionDefs: [
      { label: SECTION_LABELS.OPPORTUNITIES, items: [] },
      {
        label: SECTION_LABELS.TRANSACTIONAL,
        items: [
          (isFashionDesigner || includeSortimento) && {
            pageName: "Sortimento",
            route: ROUTES_APPLICATION_PATH.ACTIONS.COMPONENT_URL[3],
            icon: "folder",
          },
        ],
      },
      { label: SECTION_LABELS.DATA, items: [] },
    ],
    options,
  });

  return [sortimento].filter(Boolean);
};